import { useState, useEffect, useCallback } from 'react'
import axiosInstance from '../api/axios'

const useAxios = () => {
    const [response, setResponse] = useState([]);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [controller, setController] = useState();

    // useCallback을 사용하여 함수를 메모이제이션(Memoization)합니다.
    // 의존성 배열([])이 비어있으므로 이 함수는 컴포넌트 생성 시 한 번만 만들어지고 재사용됩니다.
    const axiosFetch = useCallback(async (configObj) => {
        const {
            method,
            url,
            requestConfig={}
        } = configObj;

        try {
            setLoading(true);
            const ctrl = new AbortController()
            setController(ctrl);
            
            const res = await axiosInstance[method.toLowerCase()](url, {
                ...requestConfig,
                signal: ctrl.signal
            });
            
            setError('');
            setResponse(res.data);
        } catch(err) {
            setError(err)
            setResponse([]);
        } finally {
            setLoading(false);
        }
    }, []); // 빈 배열: 외부 의존성 없음 (axiosInstance는 import된 모듈이므로 제외)

    useEffect(() => {
        // useEffect cleanup function
        return () => controller && controller.abort();
    }, [controller]);

    return [response, error, loading, axiosFetch];
}

export default useAxios